"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 2.834c-.759 0-1.375.616-1.375 1.375v2.75c0 1.2-.3 2.444-.966 3.402-.604.868-1.503 1.49-2.7 1.616v9.19h18.333v-9.19c-1.196-.125-2.096-.739-2.7-1.604-.668-.956-.967-2.2-.967-3.414V4.21c0-.759-.616-1.375-1.375-1.375h-8.25zM5.583 4.21a2.292 2.292 0 012.292-2.291h8.25a2.292 2.292 0 012.292 2.291v2.75c0 1.08.268 2.126.801 2.889.52.746 1.302 1.236 2.407 1.236.253 0 .458.206.458.459v10.083a.458.458 0 01-.458.458H2.375a.458.458 0 01-.458-.458V11.543c0-.253.205-.459.458-.459 1.103 0 1.884-.495 2.406-1.246.534-.767.802-1.815.802-2.879V4.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25 2.376c0-.253.205-.458.458-.458h4.584c.253 0 .458.205.458.458v5.042a2.75 2.75 0 11-5.5 0V2.376zm.917.458v4.584a1.833 1.833 0 103.666 0V2.834h-3.666zM5.583 12.46c0-.254.206-.46.459-.46h1.833c.253 0 .458.206.458.46v7.333a.458.458 0 01-.458.458H6.042a.458.458 0 01-.459-.458v-7.334zm.917.458v6.416h.917v-6.416H6.5zM15.667 12.46c0-.254.205-.46.458-.46h1.833c.254 0 .459.206.459.46v7.333a.458.458 0 01-.459.458h-1.833a.458.458 0 01-.458-.458v-7.334zm.916.458v6.416h.917v-6.416h-.917z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.042 14.75H2.375v-.916h3.667v.917zM21.625 14.75h-3.667v-.916h3.667v.917zM16.125 14.75h-8.25v-.916h8.25v.917zM6.042 18.418H2.375V17.5h3.667v.917zM21.625 18.418h-3.667V17.5h3.667v.917zM16.125 18.418h-8.25V17.5h8.25v.917z"
  }));
}

var _default = SvgTeams;
exports["default"] = _default;